// extracted by mini-css-extract-plugin
export var dropdownContainer = "_5b-5";
export var imageContainer = "_5b-4";
export var metricsGrid = "_5b-2";
export var productDetailContainer = "_5b-1";
export var productListContainer = "_5b-0";
export var subscriberTableContainer = "_5b-3";